module.exports = __webpack_public_path__ + "img/diario.2baa55ae.jpg";